let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("5GyXg")).then(() => parcelRequire('3VpSx'));